import React from 'react';
import {useDispatch} from 'react-redux';
import {collapseMembers, expandMembers} from '@om/redux/actions/easiplusFuneralPlan/quote';
import {OmEfpFamilyMemberCardGroup} from '@om/component-library-react';
import EfpFamilyMemberCard from './EfpFamilyMemberCard';

const EfpFamilyMemberCardGroup = ({
    isCollapsed,
    category,
    headingText,
    expandButtonText,
    displayList,
}) => {
    const dispatch = useDispatch();

    return (
        <OmEfpFamilyMemberCardGroup
            headingText={headingText}
            buttonText={expandButtonText}
            onViewMembers={() => isCollapsed
                ? dispatch(expandMembers(category))
                : dispatch(collapseMembers())
            }
        >
            <div slot="family-member-card-items">
                {displayList.map((option, index) => (
                    <EfpFamilyMemberCard
                        key={index}
                        id={option.id}
                        relationship={option.relationship}
                        age={option.age}
                        coverAmount={option.coverAmount}
                        monthlyPremium={option.monthlyPremium}
                        category={category}
                    />
                ))}
            </div>
        </OmEfpFamilyMemberCardGroup>
    );
};

export default EfpFamilyMemberCardGroup;
